// This is a magic string replaced by rollup

var SDK_VERSION = "10.17.0";
export { SDK_VERSION };